import { SVGProps, Ref, forwardRef } from 'react';

export const CheckDoubleOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M16.727 5 6.273 15.454l-5-5L0 11.728 6.273 18 18 6.273z" fill="currentColor" />
            <path d="M22.727 5 24 6.273 12.273 18 11 16.727z" fill="currentColor" />
        </g>
    </svg>
));
CheckDoubleOutlinedSize24Glyph.displayName = 'CheckDoubleOutlinedSize24Glyph';
